import { featureFlags } from "#/config/featureFlags";
import { ButtonFeatureFlag } from "#/types/featureFlags";

import { useFeatureFlags } from "./useFeatureFlags";

export const useWithdrawButtonFeatureFlag = () => {
  const featureFlag = useFeatureFlags<ButtonFeatureFlag>(
    featureFlags.withdrawButton,
  );
  const isWithdrawButtonEnabled = featureFlag?.isEnabled ?? true;
  const withdrawButtonTitle = featureFlag?.title ?? "Withdraw";
  const withdrawButtonTooltip = featureFlag?.tooltip;

  return {
    isWithdrawButtonEnabled,
    withdrawButtonTitle,
    withdrawButtonTooltip,
  };
};
